import { render } from "./UploadFileButtonComponent.vue?vue&type=template&id=77558e19&scoped=true"
import script from "./UploadFileButtonComponent.vue?vue&type=script&lang=js"
export * from "./UploadFileButtonComponent.vue?vue&type=script&lang=js"

import "./UploadFileButtonComponent.vue?vue&type=style&index=0&id=77558e19&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77558e19"]])

export default __exports__